import { Close } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Quill from "quill";
import React, { useState } from "react";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import { uiLoggerNamesChecklistAndNotes } from "src/Utils/Recon/UiLogger/Constants";
import uiLogger from "src/Utils/UiLogger";
import NewEditor from "../../PartnerCommunication/Common/NewEditor";
import "./Checklist.scss";
import DeleteChecklist from "./DeleteChecklist";

const AddChecklist = ({
  openAddChecklistModal,
  setOpenAddChecklistModal,
  setOpenChecklistModal,
  selectedBusinessPartnerName,
  checklistTitle,
  setChecklistTitle,
  checklistCategory,
  setChecklistCategory,
  checklistDynamicContent,
  setChecklistDynamicContent,
  isViewChecklistRef,
  addChecklist,
  deleteChecklist,
  addChecklistLoader,
  companyId,
  branchCode,
  businessPartnerSelectedRef,
}) => {
  const [, setQuill1] = useState<Quill>(null);
  const [openDeleteChecklist, setOpenDeleteChecklist] = useState(false);
  const maxTitleLength = 100;

  const handleChangeCategory = (e) => {
    setChecklistCategory(e.target.value);
  };

  const handleClose = () => {
    setOpenChecklistModal(true);
    setOpenAddChecklistModal(false);
    isViewChecklistRef.current = false;
  };
  return (
    <div>
      <Dialog open={openAddChecklistModal} maxWidth={DIALOG_MAX_WIDTHS.MD} fullWidth>
        <DialogTitle className="dialog-title">
          <div className="heading-m">{isViewChecklistRef.current ? "Checklist Preview" : "Add Checklist"}</div>
          <div className="vertical_center_align">
            <IconButton onClick={handleClose}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2 }}>
          <Grid sx={{ mb: 2 }}>
            <Typography className="add_checklist_title">Title*</Typography>
            <Grid className="d_flex">
              <TextField
                className="update-custom-border-radius"
                id="outlined-controlled"
                size="small"
                placeholder="Write anything"
                fullWidth
                value={checklistTitle}
                disabled={isViewChecklistRef.current}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  if (event.target.value.length <= 100) {
                    setChecklistTitle(event.target.value);
                  }
                }}
              />
              {isViewChecklistRef.current && (
                <Button
                  style={{ padding: "6px 16px" }}
                  className="ml_16"
                  variant="outlined"
                  size="medium"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    setOpenDeleteChecklist(true);
                  }}
                >
                  Delete
                </Button>
              )}
            </Grid>
            {!isViewChecklistRef.current && (
              <Typography className="add_checklist_title right_align">
                {checklistTitle.length}/{maxTitleLength}
              </Typography>
            )}
          </Grid>
          {!isViewChecklistRef.current && (
            <Grid sx={{ mb: 2 }}>
              <Typography className="add_checklist_title">Category*</Typography>
              <Grid>
                <Select
                  size="small"
                  className="update-custom-border-radius"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={checklistCategory}
                  onChange={(e) => {
                    handleChangeCategory(e);
                  }}
                  style={{ width: "300px", borderRadius: "4px" }}
                  renderValue={(value) => {
                    if (value === "PARTNER") {
                      return (
                        <span>
                          BP Specific (<span>{selectedBusinessPartnerName}</span>)
                        </span>
                      );
                    }
                    if (value === "RU") {
                      return "General";
                    }
                    return "Select Category";
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Category
                  </MenuItem>
                  <MenuItem value={"RU"}>General</MenuItem>
                  <MenuItem value={"PARTNER"}>
                    BP Specific (
                    <span
                      style={{
                        display: "inline-block",
                        maxWidth: "200px", // Adjust based on remaining space within MenuItem
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        verticalAlign: "middle",
                      }}
                    >
                      {selectedBusinessPartnerName}
                    </span>
                    )
                  </MenuItem>
                </Select>
              </Grid>
            </Grid>
          )}

          {isViewChecklistRef.current ? (
            <Grid sx={{ height: "100%" }}>
              <Stack sx={{ gap: 1, height: "100%" }}>
                <iframe
                  srcDoc={checklistDynamicContent}
                  referrerPolicy="no-referrer"
                  style={{
                    display: "block",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </Stack>
            </Grid>
          ) : (
            <NewEditor content={checklistDynamicContent} setContent={setChecklistDynamicContent} setQuill={setQuill1} />
          )}
        </DialogContent>
        {!isViewChecklistRef.current && (
          <DialogActions className="dialog-actions">
            <CustomButton
              size="medium"
              colorToken="violet"
              variant="contained"
              disabled={checklistTitle?.trim() === "" || !checklistCategory || addChecklistLoader}
              startIcon={<LoadingIcon loading={addChecklistLoader} />}
              onClick={() => {
                //   handleClose();
                addChecklist();
                uiLogger(
                  uiLoggerNamesChecklistAndNotes.UI_RE_CHECKLIST_ADD_CLICK.functionName,
                  companyId.current,
                  branchCode.current,
                  {
                    message: uiLoggerNamesChecklistAndNotes.UI_RE_CHECKLIST_ADD_CLICK.message,
                    businessPartnerId: businessPartnerSelectedRef.current,
                  }
                );
              }}
            >
              Add
            </CustomButton>
          </DialogActions>
        )}
      </Dialog>
      {openDeleteChecklist && (
        <DeleteChecklist
          openDeleteChecklist={openDeleteChecklist}
          setOpenDeleteChecklist={setOpenDeleteChecklist}
          deleteChecklist={deleteChecklist}
        />
      )}
    </div>
  );
};

export default AddChecklist;
